import { Modal, Typography } from "antd";
import { IoClose } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";

const { Title } = Typography;

const ModalWrapper = ({
  title,
  isModalOpen,
  setIsModalOpen,
  children,
  variant = "pri"
}: {
  isModalOpen: boolean;
  title: string;
  setIsModalOpen: Function;
  children: React.ReactNode;
  variant?: "pri" | "sec";
}) => {
  // Variables for styling based on variant
  let headerStyles;
  let closeIconComponent: React.ReactNode;
  let contentStyles = {};

  switch (variant) {
    case "sec":
      headerStyles = {
        backgroundColor: "#8833ff",
        padding: "10px 20px"
      };
      closeIconComponent = (
        <RxCross1
        size={20}
          style={{
            color: "white",
          }}
        />
      );
      contentStyles = {
        borderRadius: ".9075rem",
        overflow: "hidden"
      }
      break;
    case "pri":
    default:
      headerStyles = {
        backgroundColor: "#130D38",
        padding: "10px"
      };
      closeIconComponent = (
        <IoClose
          style={{
            color: "white",
            borderRadius: "50%",
            border: "1px solid white",
            marginTop: "10px",
          }}
        />
      );
      break;
  }

  return (
    <Modal
      styles={{
        header: headerStyles,
        content: { padding: "0px", ...contentStyles },
      }}
      closeIcon={closeIconComponent}
      footer={null}
      title={<Title style={{ color: "white", fontSize: "22px" }}>{title}</Title>}
      onCancel={() => setIsModalOpen(false)}
      open={isModalOpen}
    >
      {children}
    </Modal>
  );
};

export default ModalWrapper;
